import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { MapData } from 'types/Meteorology/indicesClimaticos';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface MapCarouselProps {
  maps: MapData[];
  variable: string;
  onRemove: (ano: number, mes: number) => void;
  onOpen: (map: MapData) => void;
}

export default function MapCarousel({
  maps,
  variable,
  onRemove,
  onOpen,
}: MapCarouselProps) {
  const countLabel = `${maps.length} ano${maps.length !== 1 ? 's' : ''}`;

  return (
    <div className="agro-simil-map-carousel">
      <div className="agro-simil-map-carousel-header">
        <span className="agro-simil-map-carousel-title">Mapas de Anomalia</span>
        <span className="agro-simil-map-carousel-count">{countLabel}</span>
      </div>

      <div className="agro-simil-map-carousel-track">
        {maps.map((map) => (
          <div key={`${map.ano}-${map.mes}`} className="agro-simil-map-carousel-card">
            <div className="agro-simil-map-carousel-card-header">
              <span className="agro-simil-map-carousel-card-year">{map.ano}</span>
              <button
                type="button"
                className="agro-simil-map-carousel-card-remove"
                aria-label={`Remover mapa de ${map.ano}`}
                onClick={() => onRemove(map.ano, map.mes)}
              >
                <Icon iconType="close" color={cssVar('danger-fg')} size="small" />
              </button>
            </div>
            <button
              type="button"
              className="agro-simil-map-carousel-card-image"
              aria-label={`Ver mapa de ${map.ano} em tela cheia`}
              onClick={() => onOpen(map)}
            >
              <img src={map.link} alt={`Mapa de anomalia - ${variable} ${map.ano}`} />
            </button>
            <div className="agro-simil-map-carousel-card-footer">{variable}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
